// Pure helpers shared by React, the HTML template and the static docs publisher.
export function sharingMetadata(config, locale, meta, canonical, type = 'website') {
    const image = config.images[locale];
    return {
        named: {
            description: meta.description,
            'twitter:card': 'summary_large_image',
            'twitter:title': meta.title,
            'twitter:description': meta.description,
            'twitter:image': config.origin + image.path,
            'twitter:image:alt': image.alt,
            'twitter:site': '@zild_ai',
        },
        property: {
            'og:site_name': config.siteName,
            'og:locale': locale.replace('-', '_'),
            'og:locale:alternate': locale === 'pt-BR' ? 'en_US' : 'pt_BR',
            'og:type': type,
            'og:title': meta.title,
            'og:description': meta.description,
            'og:url': canonical,
            'og:image': config.origin + image.path,
            'og:image:type': 'image/png',
            'og:image:width': String(image.width),
            'og:image:height': String(image.height),
            'og:image:alt': image.alt,
        },
    };
}

export function siteGraph(config, locale, meta, canonical) {
    const index = locale === 'en-US' ? 1 : 0;
    return {
        '@context': 'https://schema.org',
        '@graph': [
            { ...config.organization, description: config.pages['/'].description[index] },
            {
                '@type': 'WebSite', '@id': config.origin + '/#website',
                url: config.origin + '/', name: config.siteName,
                publisher: { '@id': config.organization['@id'] },
                inLanguage: ['pt-BR', 'en-US'],
            },
            {
                '@type': 'WebPage', '@id': canonical + '#webpage', url: canonical,
                name: meta.title, description: meta.description, inLanguage: locale,
                isPartOf: { '@id': config.origin + '/#website' },
                about: { '@id': config.organization['@id'] },
            },
        ],
    };
}

export const serializeSchema = value => JSON.stringify(value).replace(/</g, '\\u003c');
